import React, {useContext} from 'react';
import UserContext from '../components/common/UserContext.js';

// css
import '../assets/css/Help.css';

// reactstrap
import {Col, Row} from 'reactstrap';

// components
import PageHeader from '../components/common/PageHeader.js';
import HelpMenu from '../components/Help/HelpMenu.js';
import {toHtml} from '../components/common/utilities.js';

// images
import ksmFsaHamburger from '../assets/img/Help/ksm-fsa-request-license-hamburger.png';
import ksmFsaStepper from '../assets/img/Help/ksm-fsa-stepper.png';
import ksmCartError from '../assets/img/Help/ksm-fsa-cart-error.png';
import ksmSearchProduct from '../assets/img/Help/ksm-fsa-search-products.png';
import ksmSearchProductDetail from '../assets/img/Help/ksm-fsa-search-products-details.png';
import ksmOverdraftModal from '../assets/img/Help/ksm-fsa-overdraft-modal.png';
import ksmMyChart from '../assets/img/Help/ksm-fsa-my-chart.png';
import ksmAssignProducts from '../assets/img/Help/ksm-fsa-assign-products.png';
import ksmAssignHost from '../assets/img/Help/ksm-fsa-assign-host.png';
import ksmSaveAssign from '../assets/img/Help/ksm-fsa-save-assign-host.png';
import ksmLicensePreview from '../assets/img/Help/ksm-fsa-license-preview.png';
import ksmLicenseProcessing from '../assets/img/Help/ksm-fsa-license-processing.png';
import ksmLicenseDownload from '../assets/img/Help/ksm-fsa-license-download.png';

import {CartIcon, DeleteIcon} from "../components/common/icons";

// multilingual
import {useLocalization} from '@progress/kendo-react-intl';
import {Text} from '../components/common/MultilingualText.js';
import {
    helpEARequestLicenseAssigningProductsSectionKey,
    assigningProductsToHostsKey,
    eaAccessKey,
    helpEARequestLicenseEAAccessQAKey,
    helpEARequestLicenseEndDateChangeSectionKey,
    changingLicenseEndDatesKey,
    enterpriseAgreementsKey,
    helpEARequestLicenseEnterpriseAgreementsQAKey,
    helpEARequestLicenseErrorHandlingSectionKey,
    errorHandlingKey,
    frequentlyAskedQuestionsKey,
    helpEARequestLicenseGettingLicensesSectionKey,
    gettingLicensesKey,
    eaLicenseRequestsKey,
    hostsKey,
    helpEARequestLicenseHostsQAKey,
    licensesKey,
    helpEARequestLicenseLicensesQAKey,
    mainMessages,
    helpEARequestLicenseNavigationSectionKey,
    navigationKey,
    quickStepToGetLicensesKey,
    helpEARequestLicenseQuickStepsSectionKey,
    quickStepsGetLicensesKey,
    selectingProductsKey,
    helpEARequestLicenseSelectingProductsSectionKey,
    fsaLicensingKey,
    aboutFsaGetLicenseKey,
    managingYourCartKey,
    flexibleSpendingAccountsKey,
    fsaAccessKey,
    fsaRequestLicenseKey,
    helpFSARequestLicenseAboutKey,
    helpFSARequestLicenseQuickStepsSectionKey,
    helpFSARequestLicenseNavigationSectionKey,
    helpFSARequestLicenseSelectingProductsSectionKey,
    helpEARequestLicenseManageChartSectionKey,
    helpFSARequestLicenseAssigningProductsSectionKey,
    helpFSARequestLicenseGettingLicensesSectionKey,
    helpFSARequestLicenseErrorHandlingSectionKey,
    helpFSASummaryQAKey,
    helpFSASummaryLicensesQAKey,
    helpFSASummaryHostsQAKey, helpFSASummaryAccessQAKey,
} from '../assets/text/MultilingualText.js';
import ReassignLicenseImg from "../assets/img/Help/ksm-renew-eesof-reassign-licenses.png";

function FSARequestLicenseHelp(props) {
    const {siteLanguageDefault} = useContext(UserContext);
    const localization = useLocalization();

    let imgSource = {
        'ksm-fsa-stepper': ksmFsaStepper,
        'ksm-fsa-request-license-hamburger': ksmFsaHamburger,
        'ksm-fsa-search-products': ksmSearchProduct,
        'ksm-fsa-search-products-details': ksmSearchProductDetail,
        'ksm-fsa-cart-error': ksmCartError,
        'ksm-fsa-overdraft-modal': ksmOverdraftModal,
        'ksm-fsa-my-chart': ksmMyChart,
        'ksm-fsa-assign-products': ksmAssignProducts,
        'ksm-fsa-assign-host': ksmAssignHost,
        'ksm-fsa-save-assign-host': ksmSaveAssign,
        'ksm-fsa-license-preview': ksmLicensePreview,
        'ksm-fsa-license-processing': ksmLicenseProcessing,
        'ksm-fsa-license-download': ksmLicenseDownload,
    }

    function OrderedListItem({item}) {
        let children = null;
        let type = item.substeps && item.substeps[0] ? item.substeps[0].type : 1;

        let source = imgSource.hasOwnProperty(item.img) ? imgSource[item.img] : '';

        if (item.substeps && item.substeps.length) {
            let types = item.substeps.map(i => i.type);
            let isDashed = types.every(t => t === "dash");

            children = isDashed ?
                <>
                    {item.substeps.map(i => (
                        <OrderedListItem item={i} key={i.order}/>
                    ))}
                </> :
                type === "bullet" ?
                    <ul style={{listStyleType: 'disc'}}>
                        {item.substeps.map(i => (
                            <OrderedListItem item={i} key={i.order}/>
                        ))}
                    </ul> :
                    <ol type={type}>
                        {item.substeps.map(i => (
                            <OrderedListItem item={i} key={i.order}/>
                        ))}
                    </ol>;
        }

        if (item.type === "dash") {
            return (
                <div
                    style={{
                        ...bulletStyle,
                        ...{display: 'flex'}
                    }}
                >
                    &ndash;&nbsp;{toHtml(item.step)}
                </div>
            )
        } else if (item.cart) {
            return (
                <li>
                    <div style={{
                        display: 'flex',
                    }}>
                        {toHtml(item.step_prefix)}
                        <CartIcon style={{color: 'var(--keysight-secondary)'}}/>
                        {toHtml(item.step_suffix)}
                    </div>
                    {toHtml(item.step_suffix_two)}
                    {source ?
                        <div style={{marginLeft: -30, marginTop: '1rem'}}>
                            <img src={source} alt={item.img}/>
                        </div> :
                        <></>
                    }
                </li>
            )
        } else if (item.delete) {
            return (
                <li>
                    <div style={{
                        display: 'flex',
                    }}>
                        {toHtml(item.step_prefix)}
                        <DeleteIcon style={{color: 'var(--keysight-secondary)'}}/>
                        {toHtml(item.step_suffix)}
                    </div>
                    {toHtml(item.step_suffix_two)}
                    {source ?
                        <div style={{marginLeft: -30, marginTop: '1rem'}}>
                            <img src={source} alt={item.img}/>
                        </div> :
                        <></>
                    }
                </li>
            )
        } else {
            return (
                <li>
                    <div style={children ? {paddingBottom: 6} : {}}>
                        {toHtml(item.step)}
                    </div>
                    {children}
                    {source ?
                        <div style={{marginLeft: -30, marginTop: '1rem'}}>
                            <img src={source} alt={item.img}/>
                        </div> :
                        <></>
                    }
                </li>
            );
        }
    }

    const bulletStyle = {
        paddingTop: 6,
        paddingBottom: 6
    };

    const helpContent = {
        'header': {
            key: fsaRequestLicenseKey,
            default: mainMessages[siteLanguageDefault][fsaRequestLicenseKey]
        },
        'topics': [
            {
                key: aboutFsaGetLicenseKey,
                default: mainMessages[siteLanguageDefault][aboutFsaGetLicenseKey],
                hash: '#about-fsa-get-license'
            },
            {
                key: quickStepToGetLicensesKey,
                default: mainMessages[siteLanguageDefault][quickStepToGetLicensesKey],
                hash: '#quick-steps'
            },
            {
                key: navigationKey,
                default: mainMessages[siteLanguageDefault][navigationKey],
                hash: '#navigation'
            },
            {
                key: selectingProductsKey,
                default: mainMessages[siteLanguageDefault][selectingProductsKey],
                hash: '#selecting-products'
            },
            {
                key: managingYourCartKey,
                default: mainMessages[siteLanguageDefault][managingYourCartKey],
                hash: '#manage-cart'
            },
            {
                key: assigningProductsToHostsKey,
                default: mainMessages[siteLanguageDefault][assigningProductsToHostsKey],
                hash: '#assigning-products'
            },
            {
                key: gettingLicensesKey,
                default: mainMessages[siteLanguageDefault][gettingLicensesKey],
                hash: '#getting-licenses'
            },
            {
                key: errorHandlingKey,
                default: mainMessages[siteLanguageDefault][errorHandlingKey],
                hash: '#error-handling'
            }
        ],
        'faq': [
            {
                key: flexibleSpendingAccountsKey,
                default: mainMessages[siteLanguageDefault][flexibleSpendingAccountsKey],
                hash: '#flexible-spending-accounts-faq'
            },
            {
                key: licensesKey,
                default: mainMessages[siteLanguageDefault][licensesKey],
                hash: '#licenses-faq'
            },
            {
                key: hostsKey,
                default: mainMessages[siteLanguageDefault][hostsKey],
                hash: '#hosts-faq'
            },
            {
                key: fsaAccessKey,
                default: mainMessages[siteLanguageDefault][fsaAccessKey],
                hash: '#access-faq'
            }
        ]
    };

    const aboutContent = localization.toLanguageString(
        helpFSARequestLicenseAboutKey,
        mainMessages[siteLanguageDefault][helpFSARequestLicenseAboutKey]
    );

    const quickStepsContent = localization.toLanguageString(
        helpFSARequestLicenseQuickStepsSectionKey,
        mainMessages[siteLanguageDefault][helpFSARequestLicenseQuickStepsSectionKey]
    );

    const navigationContent = localization.toLanguageString(
        helpFSARequestLicenseNavigationSectionKey,
        mainMessages[siteLanguageDefault][helpFSARequestLicenseNavigationSectionKey]
    );

    const selectingProductsContent = localization.toLanguageString(
        helpFSARequestLicenseSelectingProductsSectionKey,
        mainMessages[siteLanguageDefault][helpFSARequestLicenseSelectingProductsSectionKey]
    );

    const managingCartContent = localization.toLanguageString(
        helpEARequestLicenseManageChartSectionKey,
        mainMessages[siteLanguageDefault][helpEARequestLicenseManageChartSectionKey]
    );

    const assigningProductsContent = localization.toLanguageString(
        helpFSARequestLicenseAssigningProductsSectionKey,
        mainMessages[siteLanguageDefault][helpFSARequestLicenseAssigningProductsSectionKey]
    );

    const gettingLicensesContent = localization.toLanguageString(
        helpFSARequestLicenseGettingLicensesSectionKey,
        mainMessages[siteLanguageDefault][helpFSARequestLicenseGettingLicensesSectionKey]
    );

    const errorHandlingContent = localization.toLanguageString(
        helpFSARequestLicenseErrorHandlingSectionKey,
        mainMessages[siteLanguageDefault][helpFSARequestLicenseErrorHandlingSectionKey]
    );

    const fsaSummaryQA = localization.toLanguageString(
        helpFSASummaryQAKey,
        mainMessages[siteLanguageDefault][helpFSASummaryQAKey]
    );

    const licensesQA = localization.toLanguageString(
        helpFSASummaryLicensesQAKey,
        mainMessages[siteLanguageDefault][helpFSASummaryLicensesQAKey]
    );

    const hostsQA = localization.toLanguageString(
        helpFSASummaryHostsQAKey,
        mainMessages[siteLanguageDefault][helpFSASummaryHostsQAKey]
    );

    const accessQA = localization.toLanguageString(
        helpFSASummaryAccessQAKey,
        mainMessages[siteLanguageDefault][helpFSASummaryAccessQAKey]
    );

    return (
        <>
            <PageHeader/>
            <div className={"ksm-page-container"}>
                <Row>
                    <Col xs="3">
                        <HelpMenu helpContent={helpContent}/>
                    </Col>
                    <Col xs="9">
                        <div
                            className={"k-h3"}
                            id="about-fsa-get-license"
                        >
                            <Text
                                textkey={aboutFsaGetLicenseKey}
                                textdefault={mainMessages[siteLanguageDefault][aboutFsaGetLicenseKey]}
                            />
                        </div>
                        <hr/>
                        <div className="section">
                            <p>{aboutContent.section_one}</p>
                            <p>{aboutContent.section_two}</p>
                            <p>{aboutContent.section_three}</p>
                        </div>

                        <div
                            className={"k-h3"}
                            id="quick-steps"
                        >
                            <Text
                                textkey={quickStepsGetLicensesKey}
                                textdefault={mainMessages[siteLanguageDefault][quickStepsGetLicensesKey]}
                            />
                        </div>
                        <hr/>
                        <div className="section">
                            {toHtml(quickStepsContent.section_one)}
                            <ol type="1">
                                {quickStepsContent.section_one_steps.map(step =>
                                    <OrderedListItem item={step} key={step.order}/>
                                )}
                            </ol>
                        </div>
                        <div
                            className={"k-h3 header"}
                            id="navigation"
                        >
                            <Text
                                textkey={navigationKey}
                                textdefault={mainMessages[siteLanguageDefault][navigationKey]}
                            />
                        </div>
                        <hr/>
                        <div className="section">
                            <ol type="1">
                                {navigationContent.section_one_steps.map(step =>
                                    <OrderedListItem item={step} key={step.order}/>
                                )}
                            </ol>
                            <p>{navigationContent.section_two}</p>
                        </div>
                        <div
                            className={"k-h3 header"}
                            id="selecting-products"
                        >
                            <Text
                                textkey={selectingProductsKey}
                                textdefault={mainMessages[siteLanguageDefault][selectingProductsKey]}
                            />
                        </div>
                        <hr/>
                        <div className="section">
                            {toHtml(selectingProductsContent.section_one)}
                            <ol type="1">
                                {selectingProductsContent.section_one_steps.map((step, index) => <div
                                    key={"ea-request-license-selecting-products-step-" + index}
                                >
                                    <OrderedListItem
                                        item={step}
                                        key={step.order}
                                    />
                                </div>)}
                            </ol>
                        </div>

                        <div
                            className={"k-h3"}
                            id="manage-cart"
                        >
                            <Text
                                textkey={managingYourCartKey}
                                textdefault={mainMessages[siteLanguageDefault][managingYourCartKey]}
                            />
                        </div>
                        <hr/>
                        <div className="section">
                            <ol type="1">
                                {managingCartContent.section_one_steps.map(step =>
                                    <OrderedListItem item={step} key={step.order}/>
                                )}
                            </ol>
                        </div>

                        <div
                            className={"k-h3 header"}
                            id="assigning-products"
                        >
                            <Text
                                textkey={assigningProductsToHostsKey}
                                textdefault={mainMessages[siteLanguageDefault][assigningProductsToHostsKey]}
                            />
                        </div>
                        <hr/>
                        <div className="section">
                            <ol type="1">
                                {assigningProductsContent.section_one_steps.map((step, index) => <div
                                    key={"ea-request-license-assigning-products-step-" + index}
                                >
                                    <OrderedListItem
                                        item={step}
                                        key={step.order}
                                    />
                                </div>)}
                            </ol>
                        </div>
                        <div
                            className={"k-h3 header"}
                            id="getting-licenses"
                        >
                            <Text
                                textkey={gettingLicensesKey}
                                textdefault={mainMessages[siteLanguageDefault][gettingLicensesKey]}
                            />
                        </div>
                        <hr/>
                        <div className="section">
                            <p>
                                {gettingLicensesContent.section_one}
                            </p>
                            <p>
                                {gettingLicensesContent.section_two}
                            </p>
                            <ol type="1">
                                {gettingLicensesContent.section_two_steps.map(step =>
                                    <OrderedListItem item={step} key={step.order}/>
                                )}
                            </ol>
                            <p>
                                {gettingLicensesContent.section_three}
                            </p>
                            <ul>
                                {gettingLicensesContent.section_three_bullets.map((bullet, index) => <li
                                    key={'ea-request-license-getting-licenses-bullet-' + index}>
                                    {toHtml(bullet)}
                                </li>)}
                            </ul>
                        </div>
                        <div
                            className={"k-h3 header"}
                            id="error-handling"
                        >
                            <Text
                                textkey={errorHandlingKey}
                                textdefault={mainMessages[siteLanguageDefault][errorHandlingKey]}
                            />
                        </div>
                        <hr/>
                        <div className="section">
                            <p>
                                {errorHandlingContent.section_one}
                            </p>
                            <ul>
                                {errorHandlingContent.section_one_bullets.map((bullet, index) => <li
                                    key={'ea-request-license-error-handling-bullet-' + index}>
                                    {toHtml(bullet)}
                                </li>)}
                            </ul>
                        </div>
                        <div className={"k-h3 header"}>
                            <Text
                                textkey={frequentlyAskedQuestionsKey}
                                textdefault={mainMessages[siteLanguageDefault][frequentlyAskedQuestionsKey]}
                            />
                        </div>
                        <hr/>
                        <div id="flexible-spending-accounts-faq">
                            <h3>
                                <Text
                                    textkey={flexibleSpendingAccountsKey}
                                    textdefault={mainMessages[siteLanguageDefault][flexibleSpendingAccountsKey]}
                                />
                            </h3>
                            <ul className="indent">
                                {fsaSummaryQA.map((questionAnswer, index) => {
                                    return (
                                        <div key={"fsa-summary-qa-" + index}>
                                            <li>
                                                {toHtml(questionAnswer.Q)}
                                                <br/>
                                                <div className="indent">
                                                    {toHtml(questionAnswer.A)}
                                                    <br/>
                                                </div>
                                            </li>
                                        </div>
                                    )
                                })}
                            </ul>
                        </div>
                        <div id="licenses-faq">
                            <h3>
                                <Text
                                    textkey={licensesKey}
                                    textdefault={mainMessages[siteLanguageDefault][licensesKey]}
                                />
                            </h3>
                            <ul className="indent">
                                {licensesQA.map((questionAnswer, index) => {
                                    return (
                                        <div key={"licenses-qa-" + index}>
                                            <li>
                                                {toHtml(questionAnswer.Q)}
                                                <br/>
                                                <div className="indent">
                                                    {toHtml(questionAnswer.A)}
                                                    <br/>
                                                </div>
                                            </li>
                                        </div>
                                    )
                                })}
                            </ul>
                        </div>
                        <div id="hosts-faq">
                            <h3>
                                <Text
                                    textkey={hostsKey}
                                    textdefault={mainMessages[siteLanguageDefault][hostsKey]}
                                />
                            </h3>
                            <ul className="indent">
                                {hostsQA.map((questionAnswer, index) => {
                                    return (
                                        <div key={"hosts-qa-" + index}>
                                            <li>
                                                {toHtml(questionAnswer.Q)}
                                                <br/>
                                                <div className="indent">
                                                    {toHtml(questionAnswer.A)}
                                                    <br/>
                                                </div>
                                            </li>
                                        </div>
                                    )
                                })}
                            </ul>
                        </div>
                        <div id="access-faq">
                            <h3>
                                <Text
                                    textkey={fsaAccessKey}
                                    textdefault={mainMessages[siteLanguageDefault][fsaAccessKey]}
                                />
                            </h3>
                            <ul className="indent">
                                {accessQA ? accessQA.map((questionAnswer, index) => {
                                    return (
                                        <div key={"ea-access-qa-" + index}>
                                            <li>
                                                {toHtml(questionAnswer.Q)}
                                                <br/>
                                                <div className="indent">
                                                    {toHtml(questionAnswer.A)}
                                                    <br/>
                                                </div>
                                            </li>
                                        </div>
                                    )
                                }) : <></>}
                            </ul>
                        </div>
                    </Col>
                </Row>
            </div>
        </>
    );
}

export default FSARequestLicenseHelp;

